import { CheckCircle2 } from "lucide-react";
import { AUTOPILOT_MODES } from "@/lib/autopilot";
import { cn } from "@/lib/utils";

export default function ModePicker({ value, onChange, disabled }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="autopilot-mode-picker">
      {AUTOPILOT_MODES.map((m) => (
        <button
          key={m.v}
          type="button"
          disabled={disabled}
          onClick={() => value !== m.v && onChange(m.v)}
          className={cn(
            "rounded-lg border p-4 text-left transition-colors duration-200 disabled:opacity-60",
            value === m.v ? "border-primary/60 bg-primary/10" : "border-border hover:border-primary/30"
          )}
          data-testid={`autopilot-mode-${m.v}`}
        >
          <p className="flex items-center gap-2 text-sm font-semibold">
            {value === m.v && <CheckCircle2 className="h-4 w-4 text-primary" />}{m.title}
          </p>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{m.desc}</p>
        </button>
      ))}
    </div>
  );
}
